// removed by extract-text-webpack-plugin
module.exports = {"container":"ffedea3a59_src-comparableSales-_PriceSwitch_container","rentToggleContainer":"_8fdc26f63d_src-comparableSales-_PriceSwitch_rentToggleContainer"};


//////////////////
// WEBPACK FOOTER
// ./src/comparableSales/PriceSwitch.css
// module id = 1759
// module chunks = 0